<app-compose-mail appendTo='body' style="z-index: 9999999;" ></app-compose-mail>
<p-dialog header="Package Sponsor" appendTo='body' *ngIf="selectedPackage" 
  [(visible)]="display" [modal]="true" [maximizable]="true" [responsive]="true"
  (onHide)='hide()'
  [ngStyle]="{'width': '70vw!important','height':'60vh'}">
  <p-growl [(value)]="msgs" [baseZIndex]='99999999999'></p-growl>


  <mat-horizontal-stepper [linear]="isLinear" #stepper>


    <mat-step [stepControl]="secondFormGroup">
      <ng-template matStepLabel>Contact</ng-template>



      <div class="li">
        <div class="label">Company Name</div>
        <div class="input">
         
            <input  pInputText type="text"  class="form-field"  [(ngModel)]="selectedPackage.companyName">
          
        </div>
      </div>



      <div class="li">
        <div class="label">Adresse</div>
        <div class="input">
         
            <input  pInputText type="text"  class="form-field"  [(ngModel)]="selectedPackage.adresse">
          
        </div>
      </div>




      <div class="li">
        <div class="label">Tel</div>
        <div class="input">
         
            <input  pInputText type="text"  class="form-field"  [(ngModel)]="selectedPackage.tel">
          
        </div>
      </div>
      <div class="li">
        <div class="label">Fax</div>
        <div class="input">
         
            <input  pInputText type="text"  class="form-field"  [(ngModel)]="selectedPackage.fax">
          
        </div>
      </div>




      <div class="li">
        <div class="label">Mobile</div>
        <div class="input">
         
            <input  pInputText type="text"  class="form-field"  [(ngModel)]="selectedPackage.mobile">
          
        </div>
      </div>



      <div class="li">
        <div class="label">Nom</div>
        <div class="input">
         
            <input  pInputText type="text"  class="form-field"  [(ngModel)]="selectedPackage.nom">
          
        </div>
      </div>

      <div class="li">
        <div class="label">Prenom</div>
        <div class="input">
         
            <input  pInputText type="text"  class="form-field"  [(ngModel)]="selectedPackage.prenom">
          
        </div>
      </div>
      <div class="li">
        <div class="label">Position</div>
        <div class="input">
         
            <input  pInputText type="text"  class="form-field"  [(ngModel)]="selectedPackage.position">
          
        </div>
      </div>

      <div class="li">
        <div class="label">E-mail</div>
        <div class="input">
            
            <input pInputText type="text"  class="form-field"  [(ngModel)]="selectedPackage.email">
         </div>
      </div>
      <div class="li">
        <div class="label">Website</div>
        <div class="input">
        
 
            <input pInputText type="text"  [(ngModel)]="selectedPackage.website"  class="form-field">
  
        </div>
      </div>

      <div class="li">
        <div class="label"></div>
        <div class="input"></div>
      </div>
    </mat-step>


    <mat-step [stepControl]="secondFormGroup">
      <ng-template matStepLabel>Package</ng-template>
      <div style="height: 50vh;">
        <div class="row">
          <div style="opacity: 0;" id='bottomConf'>

          </div>
          <div style="width: 100%;margin-bottom: 5px" id='headerConf'>

          </div>
        </div>



        <ckeditor [(ngModel)]="selectedPackage.detail" name="first" [config]="CkeditorConfig"
          [style]="{'height': '100%'}" [readonly]="false" debounce="500">
          <ckbutton [name]="'modelButton'" [command]="'modelCmd'" (click)='isModelMails=true'
            [icon]="'/assets/img/model.png'" [label]="'Model text'" [toolbar]="'clipboard,1'"> </ckbutton>
        </ckeditor>


      </div>
    </mat-step>

    <mat-step [stepControl]="secondFormGroup">
      <ng-template matStepLabel>Articles</ng-template>
      <br><br>
      Is Speaker <p-checkbox [(ngModel)]="selectedPackage.isSpeaker" binary="true"></p-checkbox>
      Is English <p-checkbox [(ngModel)]="selectedPackage.isEnglish" binary="true"></p-checkbox>
      <button class="btn btn-danger" style="margin: 5px;" (click)="resetArticles()">Reset Articles</button>
      <div style="height: 50vh;">
        <div class="row">
          <div style="opacity: 0;" id='bottomConf'>

          </div>
          <div style="width: 100%;margin-bottom: 5px" id='headerConf'>

          </div>
        </div>



        <ckeditor [(ngModel)]="selectedPackage.articles" name="first" [config]="CkeditorConfig2"
          [style]="{'height': '100%'}" [readonly]="false" debounce="500">
          <ckbutton [name]="'modelButton'" [command]="'modelCmd'" (click)='isModelMails=true'
            [icon]="'/assets/img/model.png'" [label]="'Model text'" [toolbar]="'clipboard,1'"> </ckbutton>
        </ckeditor>


      </div>
    </mat-step>




    <mat-step [stepControl]="firstFormGroup">
      <ng-template matStepLabel>Paiement</ng-template>
      <div style="height: 50vh;">

        <div style="height: 20vh;">
          <div class="row">
            <div style="opacity: 0;" id='bottomConf'>
  
            </div>
            <div style="width: 100%;margin-bottom: 5px" id='headerConf'>
  
            </div>
          </div>
  
  
  
          <ckeditor [(ngModel)]="selectedPackage.conditions" name="first" [config]="CkeditorConfig3"
            [style]="{'height': '100%'}" [readonly]="false" debounce="500">
            <ckbutton [name]="'modelButton'" [command]="'modelCmd'" (click)='isModelMails=true'
              [icon]="'/assets/img/model.png'" [label]="'Model text'" [toolbar]="'clipboard,1'"> </ckbutton>
          </ckeditor>
  
  
        </div>

        <div class="row">
          <div class="col-4">
<button (click)="resetConditions()" class="btn btn-danger" style="margin: 5px;" >Reset Conditions</button>

            <div class="form-group row">
              <label class="col-3  col-form-label">
                <strong>Entreprise</strong>
              </label>


              <p-dropdown [options]='socifacts' optionLabel='raisonSocial' [(ngModel)]="selectedPackage.socifact">
              </p-dropdown>
            </div>

          </div>



          <div>

            <div class="row">

              <input [(ngModel)]="selectedPackage.l1" type="text" size="30" pInputText>



              <input id="float-inputt1" placeholder="Editer Ligne 1" [(ngModel)]="selectedPackage.t1" type="text"
                size="30" pInputText>


            </div>
            <div class="row">


              <input id="float-inputl2" [(ngModel)]="selectedPackage.l2" type="text" size="30" pInputText>


              <input id="float-inputt2" placeholder="Editer Ligne 2" [(ngModel)]="selectedPackage.t2" type="text"
                size="30" pInputText>
            <div>
              <input id="float-inputttva2" placeholder="Percent TVA" [(ngModel)]="tvaPercent" type="text"
                size="30" pInputText>
              <button class="btn btn-danger" (click)="calcTVA()">Calculer TVA</button>
            </div>

            </div>
            <div class="row">


              <input placeholder="Editer Ligne 3" [(ngModel)]="selectedPackage.l3" type="text" size="30" pInputText>


              <input placeholder="Editer Ligne 3" [(ngModel)]="selectedPackage.t3" type="text" size="30" pInputText>


            </div>
            <div class="row">


              <input placeholder="Editer Ligne 4" [(ngModel)]="selectedPackage.l4" type="text" size="30" pInputText>


              <input placeholder="Editer Ligne 4" [(ngModel)]="selectedPackage.t4" type="text" size="30" pInputText>


            </div>
          </div>




        </div>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Done</ng-template>
      <div style="height: 50vh;margin: 20px;">
        <div class="row">
       
          <div class="col-2 textImage ">
            <div class="btn" (click)="save()"
              style="  border-radius: 4px;border:  gray 1px;border-style: dotted;height: 78px; cursor: pointer;float: left;">
              <a style=" margin-top: 20px!important; ">
                <img style=" height: 40px; cursor: pointer;margin-top: 15px!important;" src="assets/img/saveb.png"
                  alt="Save">
              </a>

            </div>

            <div class="btn" (click)="savePrint(false)"
              style="  border-radius: 4px;border:  gray 1px;border-style: dotted;height: 78px; cursor: pointer;float: left;">
              <a style=" margin-top: 20px!important; ">
                <img style=" height: 40px; cursor: pointer;margin-top: 15px!important;" src="assets/img/print.png"
                  alt="Print">
              </a>

            </div>
          
            <div class="btn" (click)="savePrint(true)"
              style="  border-radius: 4px;border:  gray 1px;border-style: dotted;height: 78px; cursor: pointer;float: left;">
              <a style=" margin-top: 20px!important; ">
                <img style=" height: 40px; cursor: pointer;margin-top: 15px!important;" src="assets/img/sendmail.png"
                  alt="Print">
              </a>

            </div>
          </div>


        </div>

      </div>

      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button (click)="stepper.reset()">Reset</button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>








</p-dialog>
<p-dialog header="Model mail" [baseZIndex]='99999999999' [(visible)]="isModelMails" [modal]="true" [responsive]="true">
  <ol>
    <li class="btn btn-block" *ngFor="let modelCores of modelsCores"
      (click)=' onChooseModelCores(modelCores);isModelMails=false'>{{modelCores.designation}}</li>
  </ol>
</p-dialog>


<style>
  .ui-dialog {
    right: 0 !important;
    bottom: 0 !important;

    left: inherit !important;
    top: inherit !important;


  }
</style>